import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

export const getAttributeMappings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings`, { headers });
};

export const getEnabledAttributeMappings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings/enabled`, { headers });
};

export const createAttributeMapping = async (mapping) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings`, { headers, body: mapping });
};

export const getAttributeMapping = async (mappingId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings/${mappingId}`, { headers });
};

export const updateAttributeMapping = async (mappingId, mapping) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings/${mappingId}`, { headers, body: mapping });
};

export const deleteAttributeMapping = async (mappingId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/attribute-mappings/${mappingId}`, { headers });
};

export const getAttributeCapabilities = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/client/${uuid}/capabilities?type=ATTRIBUTE`, { headers });
};
